<router-outlet />
<router-outlet name="popup" />
